<template>
  <v-layout class="row-message" ma-2 justify-end grow
    :class="event?.content_type ? 'content-type-' + event.content_type : ''">
    <div
      v-if="whatsAppFlowsRequestsUrl"
    >
      <v-btn
        :href="whatsAppFlowsRequestsUrl"
        icon
        target="_blank"
        title="Ver as requisições para as telas do WhatsApp Flows"
      >
        <v-icon>screenshot</v-icon>
      </v-btn>
    </div>

    <v-card class="message" :class="`${this.$vuetify.theme.dark ? 'dark-box-message' : 'light-box-message'}`">
      <v-layout grow>
        <v-layout
          class="box-message"
          column
        >
          <!-- Cabeçalho -->
          <a
            v-if="event.content && event.content.header && event.content.header.mediaUrl"
            :href="event.content.header.mediaUrl"
            :title="'Baixar ' + (event.content.header.filename || 'arquivo')"
            target="_blank"
            class="header"
          >
            <img :src="getFileIcon(event.content.header.filename)" title="Ícone" />
            {{ event.content.header.filename || 'Arquivo' }}
          </a>

          <v-layout class="dont-break-out">
            <v-flex v-if="event.content">
              <v-layout
                v-if="
                  event.content_type == 'image' ||
                  event.content_type == 'image/png'
                "
                column
              >
                <div
                  style="
                    width: 330px;
                    max-height: 330px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    max-width: 100%;
                    margin-bottom: 10px;
                    border-radius: 4px;
                  "
                >
                  <viewer
                    style="display: flex"
                    :images="[event.content.url]"
                    :options="{ movable: true, title: false, navbar: false }"
                  >
                    <img
                      v-for="src in [event.content.url]"
                      :src="src"
                      :key="src"
                      style="width: 100%; cursor: pointer"
                    />
                  </viewer>
                </div>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'click'">
                <span v-html="markdownToHtml(event.content.body.text)"></span>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'interactive_flow'">
                <span v-html="markdownToHtml(event.content.body.text)"></span>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'interactive'" column>
                <!--
                  https://developers.facebook.com/documentation/business-messaging/whatsapp/payments/payments-br/boleto/#1-send-an-order-details-message
                  https://developers.facebook.com/documentation/business-messaging/whatsapp/payments/payments-br/offsite-pix/#1-send-an-order-details-message
                -->
                <div
                  class="px-4 pa-2 mb-2 rounded-lg"
                  style="background-color: rgba(0, 0, 0, 0.1);"
                >
                  <div v-if="currentService?.source == 'infobip'">
                    <div
                      v-if="event.content?.action?.payment?.payments?.length"
                      class="text-uppercase text-caption text--secondary"
                    >
                      Pedido #{{ event.content.action.payment.payments[0].id }}
                      <v-divider class="my-2"></v-divider>
                    </div>
              <div v-for="item in (event.content?.action?.order?.items || [])" :key="item.retailerId" style="margin-bottom: 2px;">
                <strong>{{ item.name }}</strong>: R$ {{ (item.amount.value / 100).toFixed(2).replace('.', ',') }}
                  <div class="text-body-2 text--secondary">
                    Quantidade: 1
                  </div>
              </div>
                  </div>

                  <div v-else>
                    <div
                      v-if="event.content?.action?.totalAmount?.value"
                      class="text-h4 text-center pa-4"
                    >
                      {{ event.content?.action?.totalAmount?.value / 100 | currency }}
                    </div>
                  </div>
                  
                  <v-divider class="my-2"></v-divider>

                  <div class="d-flex justify-space-between">
                    <div>
                      Pagar com
                    </div>

                    <div>
                      <template
                        v-for="payment in (event?.content?.action?.payment?.payments || [])"
                      >
                        <v-icon
                          v-if="payment.type === 'BRAZIL_BOLETO'"
                          :key="payment.id"
                          class="ml-2"
                          title="Boleto">calendar_view_week</v-icon>

                        <img
                          v-if="payment.type === 'BRAZIL_PIX_DC'"
                          :key="payment.id"
                          src="https://backoffice.quiteja.com.br/assets/images/icons/pix-32x32.png"
                          title="Pix"
                          class="ml-2"
                          style="width: 16px; height: 16px;"
                        />
                      </template>
                    </div>
                  </div>

                  <div v-if="currentService?.source == 'infobip'">
                    <v-divider class="my-2"></v-divider>
                    <div class="d-flex justify-space-between">
                      <div>
                        Total
                      </div>
                      <div>
                        {{ event.content?.action?.totalAmount?.value / 100 | currency }}
                      </div>
                    </div>
                  </div>
                </div>

              <span v-html="markdownToHtml(event.content?.body?.text)"></span>
            </v-layout>
              <v-layout v-else-if="event.content_type == 'template'">
                <div
                  class="text--secondary font-italic"
                >
                  <v-icon>apps</v-icon>
                  Template
                  <a
                    :href="whatsAppTemplateUrl"
                    target="_blank"
                    title="Ver o template"
                  >
                    <strong>{{ event.content.templateName }}</strong>
                    <v-icon small>open_in_new</v-icon>
                  </a>
                </div>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'ptt'" column>
                <audio-player :file="event.content.url">
                </audio-player>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'audio'" column>
                <audio-player :file="event.content.url">
                </audio-player>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'text'" column style="padding-top: 5px;">
                <span v-html="formattedMessage"></span>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'quick_reply'" column style="padding-top: 5px;">
                <span v-html="event.content.text.replaceAll('\n','<br>')"></span>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'video'" column>
                <video
                  width="300"
                  height="300"
                  controls
                  style="outline: none; margin-bottom: 10px; border-radius: 4px"
                >
                  <source
                    :src="event.content.url"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </v-layout>
              <v-layout v-else-if="event.content_type == 'document'" column>
                <div
                  v-if="checkDocType(event.content.file_name, ['pdf'])"
                  class="preview"
                >
                  <object :data="event.content.url" type="application/pdf"></object>
                </div>

                <div class="details">
                  <div style="height: 33px">
                    <img
                      v-if="checkDocType(event.content.file_name, ['pdf'])"
                      style="height: 100%"
                      src="icon_pdf.png"
                    />
                    <img
                      v-else-if="checkDocType(event.content.file_name, ['doc','docx',])"
                      style="height: 100%"
                      src="icon_doc.png"
                    />
                    <img
                      v-else-if="checkDocType(event.content.file_name, ['xls','xlsx','csv',])
                      "
                      style="height: 100%"
                      src="icon_sheet.png"
                    />
                    <img v-else style="height: 100%" src="icon_file.png" />
                  </div>

                  <span class="mr-1 ml-2">{{
                    event.content.file_name
                  }}</span>

                  <v-spacer></v-spacer>

                  <v-btn
                    outlined
                    icon
                    color="#848484"
                    @click="
                      downloadUri({ url: event.content.url, file_name: event.content.file_name || event.content.caption })
                    "
                  >
                    <v-icon>get_app</v-icon>
                  </v-btn>
                </div>
              </v-layout>
              <v-layout v-else column class="keep-text">
                {{ event.content }}
              </v-layout>
              <span
                v-if="event.content && event.content.caption"
                v-html="markdownToHtml(event.content.caption)"
              ></span>
            </v-flex>

            <v-flex grow></v-flex>

            <v-menu v-if="event.content_type == 'text' || event.content_type == 'quick_reply'" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon style="font-size: 30px; " color="grey darken-1">
                    keyboard_arrow_down
                  </v-icon>
                </v-btn>
              </template>
              <v-list
                :class="`${
                  this.$vuetify.theme.dark
                    ? 'tertiary-background'
                    : 'secondary-background'
                }`"
              >
                <v-list-item @click="messageToReply(event.content.text)">
                  <v-list-item-title>
                    Responder
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            
            <v-flex class="pb-1 pl-2" shrink style="padding-top: 3px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar :size="21" color="grey lighten-4" v-on="on">
                    <img
                      v-if="event.user"
                      :src="event.user.profile_photo_url || '/img/default.png'"
                      alt="avatar"
                    />
                    <img
                      v-else
                      src="icon-rasa.png"
                      alt="avatar"
                    />
                    <!-- TODO colocar avatar-default caso nao tenha foto -->
                  </v-avatar>
                </template>
                <span v-if="event.user">{{
                  event.user.name
                }}</span>
                <span v-if="!event.user">Rasa</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-layout align-start justify-start v-on="on">
                  <v-icon outlined small :key="event.sent_at" v-if="!event.sent_at && !event.error_at">av_timer</v-icon>
                  <v-icon :color="doneAllIconColor(event.seen_at)" outlined small :key="event.seen_at" v-else-if="event.seen_at || event.sent_at">done_all</v-icon>
                  <v-icon outlined small color="red" :key="event.error_at" v-else>error</v-icon>
                </v-layout>
              </template>
              <span>{{
                event.status_from_delivery
              }}</span>
            </v-tooltip>

            <v-layout align-end justify-end>
              <v-layout
                shrink
                :class="`${this.$vuetify.theme.dark ? 'dark-box-message' : 'light-box-message'}`"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span class="date-event" v-on="on">{{
                      (event.created_at) | moment("from", "now")
                    }}</span>
                  </template>
                  <span>{{
                    (event.created_at) | moment("DD/MM/YYYY HH:mm:ss")
                  }}</span>
                </v-tooltip>
                <!-- <status-sent-message
                  :message="event.referent"
                  :key="event.referent.id"
                /> -->
              </v-layout>        
            </v-layout>
          </v-layout>

        </v-layout>
      </v-layout>

      <div
        class="buttons"
      >
        <v-btn
          v-if="event?.content?.action?.url"
          :href="event.content.action.url"
          :title="event.content.action.url"
          target="_blank"
        >
          <v-icon left>open_in_new</v-icon>
          {{ event.content.action.displayText }}
        </v-btn>

        <v-btn
          v-for="payment in (event?.content?.action?.payment?.payments || [])"
          :key="payment.id"
          :title="payment.code"
          @click="copyToClipboard(payment.code)"
        >
          <v-icon left>content_copy</v-icon>
          {{ payment.type === 'BRAZIL_BOLETO' ? 'Copiar código do boleto' : 'Copiar código Pix' }}
        </v-btn>

        <v-btn
          v-if="event.content && event.content.action && event.content.action.callToActionButton"
          @click="copyToClipboard(event.content.action.flowToken)"
          :title="'Copiar flow token: ' + event.content.action.flowToken"
        >
          {{ event.content.action.callToActionButton }}
        </v-btn>

        <v-btn
          v-for="button in event?.content?.action?.buttons"
          :key="button.id"
          :title="'Id: ' + button.id"
        >
          <v-icon left>reply</v-icon>
          {{ button.title }}
        </v-btn>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import jwt from "jsonwebtoken";
import environment from "@/assets/js/environment";
import { mapActions, mapGetters, mapMutations } from "vuex";

import { replyText } from "@/pages/CustomerServiceRasa/store/rasaReplyMessage.module"

export default {
  props: ["event", "debug"],
  setup() {
    const messageToReply = (message) => {
      message = message.replace(/^\n+/g, '').replace(/\n+$/g, '');
      message = message.replace(/\n+/g, '\n');

      message = message
                  .split('\n')
                  .filter(linha => !linha.trim().startsWith('>'))
                  .map(linha => `> ${linha}`)
                  .join('\n');
      
      message += '\n';
      replyText.value = message
    }

    return {
      messageToReply,
    };
  },
  computed: {
    ...mapGetters('rasaServices', {
      currentService: 'currentService',
    }),

    formattedMessage() {
      // Divide a mensagem em linhas e aplica formatação às citações
      return this.event.content.text
        .split("\n")
        .map((line) => {
          if (line.startsWith(">")) {
            // Estilo para linhas que começam com '>'
            return `<div style="padding-left: 10px; border-left: 4px solid #34b7f1; font-size: 13px; font-style: italic; margin-bottom: 5px;">${line.substring(1).trim()}</div>`;
          }
          // Estilo padrão para linhas normais
          return `<div>${line}</div>`;
        })
        .join("");
    },

    /**
     * Retorna a URL para visualizar as requisições do WhatsApp Flows.
     */
    whatsAppFlowsRequestsUrl() {
      const baseUrl = environment.hermesUrl + '/whatsapp_flows';

      if (!this.event) {
        return null;
      }

      if (!this.event.sender || this.event.content_type !== 'interactive_flow') {
        return null;
      }

      let params = {
        from: this.event.sender,
      };

      let flowTokenEncoded = this.event.content?.action?.flowToken;

      if (flowTokenEncoded) {
        try {
          const flowTokenDecoded = jwt.decode(flowTokenEncoded) || {};

          if (flowTokenDecoded.deal_id) {
            params.deal_id = flowTokenDecoded.deal_id;
          }
        } catch (error) {
          console.error('Não foi possível decodificar o flow_token:', error);
        }
      }

      params.flow_token = this.event.content?.action?.flowToken;

      return baseUrl + '?' + new URLSearchParams(params).toString();
    },

    whatsAppTemplateUrl() {
      if (this.currentService && this.currentService.contact) {
        return `https://portal.infobip.com/channels-and-numbers/channels/whatsapp/senders/${this.currentService.contact}/templates`;
      }

      return 'https://portal.infobip.com/channels-and-numbers/channels/whatsapp/templates'
    },
  },

  methods: {
    ...mapActions("rasaUpload", {
      downloadUri: "download",
    }),

    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),

    checkDocType(file_name, types) {
      let name_splitted = file_name.split(".");
      let type = name_splitted[name_splitted.length - 1];
      return types.indexOf(type) > -1;
    },

    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.showSnackbar('Copiado');
        }).catch(() => {
          this._fallbackCopy(text);
        });
      } else {
        this._fallbackCopy(text);
      }
    },

    _fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.showSnackbar('Copiado');
    },

    doneAllIconColor(was_seen) {
      if (was_seen){ return 'blue' }
      else { return '' }
    },

    getFileIcon(filename) {
      if (!filename) {
        return 'icon_file.png';
      }

      let extension = filename.split('.').pop();

      if (!extension) {
        return 'icon_file.png';
      }

      extension = extension.toLowerCase();

      return {
        'doc': 'icon_doc.png',
        'docx': 'icon_word.png',
        'pdf': 'icon_pdf.png',
        'xls': 'icon_sheet.png',
        'xlsx': 'icon_sheet.png',
      }[extension] || 'icon_file.png';
    },

    /** 
     * Converte um texto markdown para HTML.
     * 
     * Marcações suportadas:
     * - Itálico
     * - Negrito
     */
    markdownToHtml(text) {
        if (!text) {
            return '';
        }

        let html = text;

        // Negrito: *texto*
        html = text.replace(/\*(.+?)\*/g, '<strong>$1</strong>');

        // Itálico: _texto_
        html = html.replace(/(\*|_)(.+?)\1/g, '<em>$2</em>');

        return html;
    },
  },
};
</script>

<style lang="scss" scoped>
.row-message {
  max-height: max-content;
  padding: 0;

  &.content-type-click,
  &.content-type-interactive_flow {
    .message {
      .dont-break-out {
        white-space: pre-line;
      }
    }
  }

  &.content-type-document {
    .preview {
      max-height: 330px;
      max-width: 100%;
      margin-left: -8px;
      margin-top: -4px;

      object {
        width: 100%;
      }
    }

    .details {
      align-items: center;
      background-color: rgba(0, 0, 0, 0.2);
      border-end-end-radius: 6px;
      border-end-start-radius: 6px;
      display: flex;
      font-size: 14px;
      margin-bottom: 8px;
      margin-left: -8px;
      margin-right: 8px;
      margin-top: -8px;
      padding: 12px 18px;
    }
  }

  &.content-type-interactive {
    .v-divider {
      border-style: dashed;
      margin: auto -8px;
    }
  }

  .message {
    border-radius: 15px;
    border-radius: 12px 12px 0 12px;

    .box-message {
      border-radius: 12px 12px 0 12px;
      padding: 8px 12px;
      min-width: 240px;
      max-width: 440px;
      z-index: 2;

      .dont-break-out {
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
      }

      .keep-text {
        max-width: 380px;
      }

      &.debug {
        border-radius: 12px 12px 12px 0;
      }
    }

    .date-event {
      font-size: 12px;
      margin-left: 10px;
    }

    .box-status {
      min-width: 17px;
      margin-top: -5px;
    }

    .buttons {
      display: flex;
      flex-direction: column;

      a, button {
        background-color: transparent;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-top: 1px solid rgb(218, 221, 225);
        box-shadow: none;
        color: #2196f3;
        font-size: 14px;
        text-transform: none;
      }
    }

    .header {
      align-items: center;
      background-color: #ddd;
      border-radius: 6px;
      display: flex;
      color: rgb(10, 10, 10);
      font-size: 14px;
      margin: -4px -8px 4px -8px;
      padding: 13px 19px;
      text-decoration: none;

      img {
        height: 30px;
        margin-right: 10px;
      }
    }

    &.debug {
      border-radius: 12px 12px 12px 0;
    }
  }
  .light-box-message {
    background-color: #d9fdd3 !important;
    background: #d9fdd3 !important;
  }

  .dark-box-message {
    background-color: #005c4b !important;
    background: #005c4b !important;
  }
}

.theme--dark {
  .row-message {
    .buttons {
      a, button {
        color: #21C063;
      }
    }

    .header {
      background-color: #333;
      color: #FAFAFA
    }
  }
}
</style>
